import { createApp } from "vue";
import App from "./App.vue";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import router from "./router";
import axios from "axios";
import VueAxios from "vue-axios";
import i18n from "./lang";
import store from "./store";
import { QCalendarMonth } from '@quasar/quasar-ui-qcalendar'
import '@quasar/quasar-ui-qcalendar/dist/index.css'
import './registerServiceWorker'

const app = createApp(App);

app.use(i18n);
app.use(Quasar, quasarUserOptions);
app.use(router);
app.use(VueAxios, axios);
app.use(store);
app.component('QCalendarMonth', QCalendarMonth);

app.mount("#app");
  
  store.dispatch('global/getPageLang', i18n)
